import { render, staticRenderFns } from "./ConfigureableList.vue?vue&type=template&id=5f32ecdd&scoped=true"
import script from "./ConfigureableList.vue?vue&type=script&lang=js"
export * from "./ConfigureableList.vue?vue&type=script&lang=js"
import style0 from "./ConfigureableList.vue?vue&type=style&index=0&id=5f32ecdd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f32ecdd",
  null
  
)

export default component.exports